<script lang="ts">
	import Link from "./Link.svelte";
	import Icon from "./Icon.svelte";
	import downloadIcon from "../../../core/assets/icons/download.svg?raw";
	import type { Attachment } from "../../../core/schema/Attachment";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { getExtensionOfS3File } from "../../../core/schema/getExtensionOfS3File.js";
	import { getTranslate } from "../utils/getTranslate";
	import translations from "./AttachmentTable.translations.json";

	// {getExtensionOfS3File(attachment)}
	export let attachments: Attachment[];
	let tableClass = "";
	export { tableClass as class };

	const translate = getTranslate(translations);

	const { STORAGE_URL } = getGlobalSettings();
</script>

<div class="responsive-table {tableClass}">
	<table>
		<thead>
			<tr>
				<th>{translate("nameOfAttachment")}</th>
				<th class="hidden">{translate("name")}</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			{#each attachments as attachment}
				<tr>
					<td>{attachment.title}</td>
					<td class="hidden uppercase">{getExtensionOfS3File(attachment)}</td>
					<td>
						<Link
							class="text-primary group flex items-center justify-end gap-2"
							noUnderline
							href="{STORAGE_URL}/{attachment.path}"
							target="_blank"
						>
							<span class="decoration-primary transition-[text-decoration] duration-300 ease-in-out">
								{translate("download")}
							</span>
							<Icon icon={downloadIcon} class="w-6" />
						</Link>
					</td>
				</tr>
			{/each}
		</tbody>
	</table>
</div>
